module.exports = __webpack_public_path__ + "static/media/henrik.4d668e8d.png";